import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../lib/auth";
import { Spinner } from "../components/ui";

// Intrarea în sesiunea de suport deschisă din platforma de operator. Token-ul vine în fragmentul URL
// (#token=...), care nu ajunge în loguri de server și nici în header-ul Referer.
export default function Impersonate() {
  const { adopt } = useAuth();
  const nav = useNavigate();
  const done = useRef(false); // StrictMode rulează efectul de două ori; token-ul se consumă o singură dată
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    history.replaceState(null, "", "/impersonate"); // scoate token-ul din bara de adrese / istoric
    if (token) adopt(token);
    nav(token ? "/" : "/login", { replace: true });
  }, [adopt, nav]);
  return <Spinner />;
}
